import api from '../api'

export default {
    namespaced: true,
    state: {
        channelPayment: [],// 渠道类型
        channelList: {// 渠道列表
            beanList: [],
            total: 0
        },
        channelClubList: {// 俱乐部渠道配置
            beanList: [],
            total: 0
        },
        channelClubsQuery: [], // 配置俱乐部的数量
        bankList: [],// 银行卡列表
    },
    mutations: {
        setStateChannelPayment(state, info) {
            state.channelPayment = info
        },
        setStateChannelList(state, info) {
            state.channelList = info
        },
        setStateChannelClubList(state, info) {
            state.channelClubList = info
        },
        setStateChannelClubsQuery(state, info) {
            state.channelClubsQuery = info
        },
        setStateBankList(state, info) {
            state.bankList = info
        }
    },
    actions: {
        getChannelClubsQuery({commit}) {
            return api.post('/pay/channel/clubs/query', '拉取代充渠道配置俱乐部的数量').then(res => {
                commit('setStateChannelClubsQuery', res.data)
            })
        },
        getChannelPayment({commit}) {
            return api.post('/pay/channel/query_payment', '获取支付渠道类型').then(res => {
                commit('setStateChannelPayment', res.data)
            })
        },
        getChannelPaymentQuery(store, params) {
            return api.post('/pay/channel/payment/query', '获取支付商的配置内容', params)
        },
        getChannelList({commit, dispatch}, params) {
            return api.post('/pay/channel/list', '渠道列表', params).then(res => {
                commit('setStateChannelList', res.data);
                dispatch('getChannelClubsQuery')
            })
        },
        createChannel(store, params) {
            return api.post('/pay/channel/create', '新建渠道', params)
        },
        deleteChannel(store, params) {
            return api.post('/pay/channel/delete', '渠道删除', params)
        },
        deleteSDK(store, params) {
            return api.post('/pay/channel/payment/sdk_delete', '删除第三方支付配置', params)
        },
        setSDKDefault(store, params) {
            return api.post('/pay/channel/payment/sdk_default', '设置默认支付sdk配置', params)
        },
        updateChannelRebate(store, params) {
            return api.post('/pay/channel/update_open_rebate', '开启/停用战绩返佣', params)
        },
        getChannelClubList({commit}, params) {
            return api.post('/pay/channel/selected_club_list', '查询渠道分配的俱乐部', params).then(res => {
                commit('setStateChannelClubList', res.data)
            })
        },
        getChannelUnSelectClubList({commit}, params) {
            return api.post('/pay/channel/tribe_club_list', '根据联盟id查询未分配的俱乐部列表', params).then(res => {
                commit('setStateChannelClubList', res.data)
            })
        },
        addChannelClub(store, params) {
            return api.post('/pay/channel/save_channel_club', '分配俱乐部保存', params)
        },
        updateChannel(store, params) {
            return api.post('/pay/channel/update', '代充渠道更新', params)
        },
        updateChannelInfo(store, params) {
            return api.post('/pay/channel/info/update', '渠道信息配置更新', params)
        },
        getBankList({commit}){
            return api.post('/pay/channel/bank/list', '拉取所有银行卡信息').then(res => {
                commit('setStateBankList', res.data)
            });
        },
        getChannelBankList(state, params) {
            return api.post('/pay/channel/bank/list', '拉取银行卡信息', params)
        },
        updateChannelBank(state, params) {
            return api.post('/pay/channel/bank/save', '保存代充渠道支持银行卡信息', params)
        }
    }
}